const index = () => import('./Index');

//2019年省级工业转型升级专项资金
export default {
  routes: [
    {
      path: '/inves/inves/v2021/index',
      name: 'inves_inves_v2021_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/inves/inves/v2021/router.js